import { render, staticRenderFns } from "./Costos.vue?vue&type=template&id=f13a8536&scoped=true"
import script from "./Costos.vue?vue&type=script&lang=js"
export * from "./Costos.vue?vue&type=script&lang=js"
import style0 from "./Costos.vue?vue&type=style&index=0&id=f13a8536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13a8536",
  null
  
)

export default component.exports